var map = {
	"./404.svg": "8a81",
	"./DownArrRounded.svg": "8629",
	"./DownArrow.svg": "9a52",
	"./Private_Storage.svg": "fdf1",
	"./back-arrow.svg": "9e57",
	"./back_admin_dashboard.svg": "4b23",
	"./back_admin_dashboard_white.svg": "c849",
	"./box.svg": "404f",
	"./building-min.png": "9f27",
	"./cart.svg": "6f5d",
	"./cart_empty_state.svg": "a211",
	"./chat-min.png": "d897",
	"./closePopup.svg": "f814",
	"./companys/aoc.png": "806c",
	"./companys/apple.png": "41fb",
	"./companys/dell.png": "736e",
	"./companys/fujitsu.png": "6024",
	"./companys/hp.png": "5ce4",
	"./companys/lenovo.png": "43a4",
	"./companys/lg.png": "7517",
	"./contact_us.svg": "16bb",
	"./courier-min.png": "9715",
	"./deletedSuccess.svg": "2c8c",
	"./deliveryForm.svg": "ed63",
	"./deny-min.png": "77fd",
	"./dhlLogo.png": "c18f",
	"./discounts.svg": "a30d",
	"./dot.svg": "de15",
	"./dpdLogo.png": "9285",
	"./emptySearch.svg": "c9e8",
	"./emptyState.png": "51e9",
	"./emptyState.svg": "d529",
	"./emptyStateCart.png": "2cbf",
	"./export_min.png": "3a2b",
	"./fabric.svg": "d326",
	"./facebook.svg": "aaa3",
	"./faq.svg": "0ead",
	"./fi-rr-shield-check.svg": "e7f8",
	"./freeDelivery.svg": "b03f",
	"./home.svg": "86e6",
	"./inPostCourier.png": "1aca",
	"./inpostPaczkomatLogo.png": "a058",
	"./kompreLogo-min.png": "d437",
	"./logo.png": "cf05",
	"./logoKompre-min.png": "0b9d",
	"./logout.svg": "309a",
	"./message.svg": "e36a",
	"./messageSent.svg": "f1f6",
	"./minus.svg": "e9b2",
	"./money-min.png": "b772",
	"./money.png": "875b",
	"./money.svg": "f7cb",
	"./najtansze_komputery_poleasingowe_i_laptopy_poleasingowe-min.png": "f50b",
	"./navbarImgs/b2b.svg": "823d",
	"./navbarImgs/blog.svg": "cb3a",
	"./navbarImgs/customer-service.svg": "809b",
	"./navbarImgs/logistics-delivery.svg": "8979",
	"./navbarImgs/price-tag.svg": "0674",
	"./navbarImgs/product-photo.svg": "136a",
	"./navbarImgs/tax.svg": "9a1b",
	"./newIcons/banner.svg": "c74b",
	"./newIcons/blog.svg": "afc4",
	"./newIcons/discount 2.svg": "cf14",
	"./newIcons/discount.svg": "1be3",
	"./newIcons/fi-rr-add.svg": "c89c",
	"./newIcons/fi-rr-comment.svg": "123b",
	"./newIcons/fi-rr-home.svg": "7d2c",
	"./newIcons/fi-rr-link.svg": "56ef",
	"./newIcons/fi-rr-list.svg": "65f1",
	"./newIcons/fi-rr-power.svg": "1181",
	"./newIcons/newsletter 2.svg": "b643",
	"./newIcons/newsletter.svg": "7180",
	"./newIcons/price-tag.svg": "291f",
	"./nosearchdata-min.png": "6339",
	"./openMessage.svg": "8aab",
	"./opinion.svg": "36b3",
	"./optionalMessage.svg": "ed65",
	"./payuLogo.png": "e591",
	"./plus.svg": "8a37",
	"./products.svg": "e1d5",
	"./przelewy24Logo.svg": "ce2b",
	"./remove.svg": "7e18",
	"./safetyPurchase/box.png": "542c",
	"./safetyPurchase/checked.png": "7a11",
	"./safetyPurchase/family.png": "fa9f",
	"./safetyPurchase/photo.png": "5d20",
	"./safetyPurchase/time.png": "a9c9",
	"./safetyPurchase/trust.png": "6a50",
	"./safetyPurchase/years.png": "e82f",
	"./search.svg": "51f2",
	"./shopingFailure.svg": "de43",
	"./shoppingCartMobile.svg": "7745",
	"./spring.svg": "1a9e",
	"./stats.svg": "f2a2",
	"./svg/fi-rr-add.svg": "a1a9",
	"./svg/fi-rr-alarm-clock.svg": "0e6e",
	"./svg/fi-rr-align-center.svg": "26c9",
	"./svg/fi-rr-align-justify.svg": "abfb",
	"./svg/fi-rr-align-left.svg": "4145",
	"./svg/fi-rr-align-right.svg": "5299",
	"./svg/fi-rr-ambulance.svg": "7882",
	"./svg/fi-rr-angle-double-left.svg": "3c5f",
	"./svg/fi-rr-angle-double-right.svg": "f689",
	"./svg/fi-rr-angle-double-small-left.svg": "addc",
	"./svg/fi-rr-angle-double-small-right.svg": "d1da",
	"./svg/fi-rr-angle-down.svg": "f37c",
	"./svg/fi-rr-angle-left.svg": "dda6",
	"./svg/fi-rr-angle-right.svg": "049a",
	"./svg/fi-rr-angle-small-down.svg": "31f8",
	"./svg/fi-rr-angle-small-left.svg": "ec55",
	"./svg/fi-rr-angle-small-right.svg": "c78d",
	"./svg/fi-rr-angle-small-up.svg": "5ba2",
	"./svg/fi-rr-angle-up.svg": "ef09",
	"./svg/fi-rr-apps-add.svg": "0584",
	"./svg/fi-rr-apps-delete.svg": "16e6",
	"./svg/fi-rr-apps-sort.svg": "faf4",
	"./svg/fi-rr-apps.svg": "09b0",
	"./svg/fi-rr-archive.svg": "387d",
	"./svg/fi-rr-arrow-down.svg": "fbc9",
	"./svg/fi-rr-arrow-left.svg": "4824",
	"./svg/fi-rr-arrow-right.svg": "48af",
	"./svg/fi-rr-arrow-small-down.svg": "1f2d",
	"./svg/fi-rr-arrow-small-left.svg": "89b4",
	"./svg/fi-rr-arrow-small-right.svg": "201d",
	"./svg/fi-rr-arrow-small-up.svg": "00ae",
	"./svg/fi-rr-arrow-up.svg": "ae55",
	"./svg/fi-rr-asterisk.svg": "bb33",
	"./svg/fi-rr-backpack.svg": "df5a",
	"./svg/fi-rr-badge.svg": "4ced",
	"./svg/fi-rr-ban.svg": "625a",
	"./svg/fi-rr-band-aid.svg": "8b8a",
	"./svg/fi-rr-bank.svg": "0dd2",
	"./svg/fi-rr-barber-shop.svg": "aee8",
	"./svg/fi-rr-baseball.svg": "71fb",
	"./svg/fi-rr-basketball.svg": "8424",
	"./svg/fi-rr-bell-ring.svg": "90d6",
	"./svg/fi-rr-bell-school.svg": "d157",
	"./svg/fi-rr-bell.svg": "c382",
	"./svg/fi-rr-billiard.svg": "fb60",
	"./svg/fi-rr-bold.svg": "9fc6",
	"./svg/fi-rr-book-alt.svg": "a391",
	"./svg/fi-rr-book.svg": "a2ca",
	"./svg/fi-rr-bookmark.svg": "4c29",
	"./svg/fi-rr-bowling.svg": "1e36",
	"./svg/fi-rr-box-alt.svg": "b4f2",
	"./svg/fi-rr-box.svg": "8ec7",
	"./svg/fi-rr-briefcase.svg": "bfa7",
	"./svg/fi-rr-broom.svg": "acec",
	"./svg/fi-rr-browser.svg": "22c3",
	"./svg/fi-rr-brush.svg": "47d2",
	"./svg/fi-rr-bug.svg": "dc36",
	"./svg/fi-rr-building.svg": "385b",
	"./svg/fi-rr-bulb.svg": "8bea",
	"./svg/fi-rr-calculator.svg": "f2db",
	"./svg/fi-rr-calendar.svg": "76b9",
	"./svg/fi-rr-camera.svg": "6bd2",
	"./svg/fi-rr-caret-down.svg": "ce5a",
	"./svg/fi-rr-caret-left.svg": "9600",
	"./svg/fi-rr-caret-right.svg": "fa99",
	"./svg/fi-rr-caret-up.svg": "5a62",
	"./svg/fi-rr-check.svg": "cffc",
	"./svg/fi-rr-checkbox.svg": "ae51",
	"./svg/fi-rr-chess.svg": "cbe3",
	"./svg/fi-rr-circle-small.svg": "a72e",
	"./svg/fi-rr-circle.svg": "d7b9",
	"./svg/fi-rr-clip.svg": "8d51",
	"./svg/fi-rr-clock.svg": "0d56",
	"./svg/fi-rr-cloud-check.svg": "b893",
	"./svg/fi-rr-cloud-disabled.svg": "90c7",
	"./svg/fi-rr-cloud-download.svg": "a98d",
	"./svg/fi-rr-cloud-share.svg": "ece5",
	"./svg/fi-rr-cloud-upload.svg": "4836",
	"./svg/fi-rr-cloud.svg": "1ef3",
	"./svg/fi-rr-comment-alt.svg": "b74e",
	"./svg/fi-rr-comment.svg": "d377",
	"./svg/fi-rr-compress-alt.svg": "1890",
	"./svg/fi-rr-compress.svg": "11f0",
	"./svg/fi-rr-computer.svg": "e8b7",
	"./svg/fi-rr-cookie.svg": "4a56",
	"./svg/fi-rr-copy-alt.svg": "de7f",
	"./svg/fi-rr-copy.svg": "78e0",
	"./svg/fi-rr-copyright.svg": "760e",
	"./svg/fi-rr-cream.svg": "784a",
	"./svg/fi-rr-credit-card.svg": "64ac",
	"./svg/fi-rr-cross-circle.svg": "4580",
	"./svg/fi-rr-cross-small.svg": "b22a",
	"./svg/fi-rr-cross.svg": "732c",
	"./svg/fi-rr-crown.svg": "5aed",
	"./svg/fi-rr-cursor-finger.svg": "021b",
	"./svg/fi-rr-cursor-plus.svg": "3ff8",
	"./svg/fi-rr-cursor-text-alt.svg": "86df",
	"./svg/fi-rr-cursor-text.svg": "7fd1",
	"./svg/fi-rr-cursor.svg": "62b6",
	"./svg/fi-rr-dart.svg": "dd83",
	"./svg/fi-rr-dashboard.svg": "ef50",
	"./svg/fi-rr-data-transfer.svg": "12d1",
	"./svg/fi-rr-database.svg": "3258",
	"./svg/fi-rr-delete.svg": "6ff2",
	"./svg/fi-rr-diamond.svg": "7692",
	"./svg/fi-rr-dice.svg": "be7b",
	"./svg/fi-rr-diploma.svg": "be6f",
	"./svg/fi-rr-disk.svg": "aa46",
	"./svg/fi-rr-doctor.svg": "380a",
	"./svg/fi-rr-document-signed.svg": "6152",
	"./svg/fi-rr-document.svg": "42b7",
	"./svg/fi-rr-dollar.svg": "9916",
	"./svg/fi-rr-download.svg": "00da",
	"./svg/fi-rr-duplicate.svg": "ae69",
	"./svg/fi-rr-e-learning.svg": "ad7c",
	"./svg/fi-rr-earnings.svg": "bae2",
	"./svg/fi-rr-edit-alt.svg": "0bc2",
	"./svg/fi-rr-edit.svg": "b769",
	"./svg/fi-rr-envelope.svg": "ff19",
	"./svg/fi-rr-euro.svg": "e492",
	"./svg/fi-rr-exclamation.svg": "3c65",
	"./svg/fi-rr-expand.svg": "4917",
	"./svg/fi-rr-eye-crossed.svg": "6835",
	"./svg/fi-rr-eye-dropper.svg": "fdcd",
	"./svg/fi-rr-eye.svg": "3d35",
	"./svg/fi-rr-feather.svg": "4c44",
	"./svg/fi-rr-file-add.svg": "af5d",
	"./svg/fi-rr-file-ai.svg": "494a",
	"./svg/fi-rr-file-check.svg": "7f3d",
	"./svg/fi-rr-file-delete.svg": "21c7",
	"./svg/fi-rr-file-eps.svg": "1a6f",
	"./svg/fi-rr-file-gif.svg": "854e",
	"./svg/fi-rr-file-music.svg": "f987",
	"./svg/fi-rr-file-psd.svg": "8446",
	"./svg/fi-rr-file.svg": "e3b2",
	"./svg/fi-rr-fill.svg": "96cc",
	"./svg/fi-rr-film.svg": "dcae",
	"./svg/fi-rr-filter.svg": "fbee",
	"./svg/fi-rr-fingerprint.svg": "52a3",
	"./svg/fi-rr-flag.svg": "0d65",
	"./svg/fi-rr-flame.svg": "82ee",
	"./svg/fi-rr-flip-horizontal.svg": "db74",
	"./svg/fi-rr-folder-add.svg": "1736",
	"./svg/fi-rr-folder.svg": "bcbd",
	"./svg/fi-rr-following.svg": "3f64",
	"./svg/fi-rr-football.svg": "b2c7",
	"./svg/fi-rr-form.svg": "5404",
	"./svg/fi-rr-forward.svg": "691a",
	"./svg/fi-rr-ftp.svg": "488c",
	"./svg/fi-rr-gallery.svg": "ae83",
	"./svg/fi-rr-glasses.svg": "474f",
	"./svg/fi-rr-globe-alt.svg": "ec26",
	"./svg/fi-rr-globe.svg": "f168",
	"./svg/fi-rr-golf.svg": "975c",
	"./svg/fi-rr-graduation-cap.svg": "06dc",
	"./svg/fi-rr-graphic-tablet.svg": "5cdd",
	"./svg/fi-rr-grid-alt.svg": "08fa",
	"./svg/fi-rr-grid.svg": "b31c",
	"./svg/fi-rr-gym.svg": "a36d",
	"./svg/fi-rr-headphones.svg": "79e7",
	"./svg/fi-rr-headset.svg": "d754",
	"./svg/fi-rr-heart.svg": "da0c",
	"./svg/fi-rr-home.svg": "d85b",
	"./svg/fi-rr-hourglass-end.svg": "4591",
	"./svg/fi-rr-hourglass.svg": "6704",
	"./svg/fi-rr-ice-skate.svg": "d28e",
	"./svg/fi-rr-id-badge.svg": "2480",
	"./svg/fi-rr-inbox.svg": "e6d6",
	"./svg/fi-rr-incognito.svg": "1050",
	"./svg/fi-rr-indent.svg": "f200",
	"./svg/fi-rr-infinity.svg": "e0d5",
	"./svg/fi-rr-info.svg": "472b",
	"./svg/fi-rr-interactive.svg": "4f6a",
	"./svg/fi-rr-interlining.svg": "f947",
	"./svg/fi-rr-interrogation.svg": "bcc3",
	"./svg/fi-rr-italic.svg": "2858",
	"./svg/fi-rr-jpg.svg": "cab9",
	"./svg/fi-rr-key.svg": "c675",
	"./svg/fi-rr-keyboard.svg": "55d0",
	"./svg/fi-rr-label.svg": "d19b",
	"./svg/fi-rr-laptop.svg": "bb8a",
	"./svg/fi-rr-lasso.svg": "4640",
	"./svg/fi-rr-layers.svg": "7360",
	"./svg/fi-rr-layout-fluid.svg": "9cf9",
	"./svg/fi-rr-letter-case.svg": "2193",
	"./svg/fi-rr-life-ring.svg": "b597",
	"./svg/fi-rr-line-width.svg": "42c7",
	"./svg/fi-rr-link.svg": "63d3",
	"./svg/fi-rr-lipstick.svg": "236b",
	"./svg/fi-rr-list-check.svg": "b3fc",
	"./svg/fi-rr-list.svg": "e239",
	"./svg/fi-rr-location-alt.svg": "3c71",
	"./svg/fi-rr-lock-alt.svg": "9090",
	"./svg/fi-rr-lock.svg": "10bb",
	"./svg/fi-rr-magic-wand.svg": "a736",
	"./svg/fi-rr-makeup-brush.svg": "110d",
	"./svg/fi-rr-marker-time.svg": "a316",
	"./svg/fi-rr-marker.svg": "4b5e",
	"./svg/fi-rr-medicine.svg": "a261",
	"./svg/fi-rr-megaphone.svg": "a6ad",
	"./svg/fi-rr-menu-burger.svg": "3618",
	"./svg/fi-rr-menu-dots-vertical.svg": "a1c7",
	"./svg/fi-rr-menu-dots.svg": "e946",
	"./svg/fi-rr-microphone.svg": "328b",
	"./svg/fi-rr-minus-small.svg": "8a44",
	"./svg/fi-rr-minus.svg": "d896",
	"./svg/fi-rr-mobile.svg": "64b4",
	"./svg/fi-rr-mode-landscape.svg": "a108",
	"./svg/fi-rr-mode-portrait.svg": "59b6",
	"./svg/fi-rr-money.svg": "58c6",
	"./svg/fi-rr-mouse.svg": "913c",
	"./svg/fi-rr-music-alt.svg": "d8ff",
	"./svg/fi-rr-music.svg": "1b28",
	"./svg/fi-rr-network-cloud.svg": "97ce",
	"./svg/fi-rr-network.svg": "3857",
	"./svg/fi-rr-notebook.svg": "7b03",
	"./svg/fi-rr-opacity.svg": "5788",
	"./svg/fi-rr-package.svg": "a34f",
	"./svg/fi-rr-paint-brush.svg": "377c",
	"./svg/fi-rr-palette.svg": "591f",
	"./svg/fi-rr-paper-plane.svg": "cde8",
	"./svg/fi-rr-password.svg": "d3c7",
	"./svg/fi-rr-pause.svg": "47c7",
	"./svg/fi-rr-pencil.svg": "cbb1",
	"./svg/fi-rr-pharmacy.svg": "0a64",
	"./svg/fi-rr-physics.svg": "b14f",
	"./svg/fi-rr-picture.svg": "bce9",
	"./svg/fi-rr-ping-pong.svg": "e311",
	"./svg/fi-rr-play-alt.svg": "89ec",
	"./svg/fi-rr-play.svg": "e3dd",
	"./svg/fi-rr-playing-cards.svg": "13ef",
	"./svg/fi-rr-plus-small.svg": "d0a2",
	"./svg/fi-rr-plus.svg": "23f2",
	"./svg/fi-rr-poker-chip.svg": "b29c",
	"./svg/fi-rr-portrait.svg": "9d86",
	"./svg/fi-rr-pound.svg": "df14",
	"./svg/fi-rr-power.svg": "12e9",
	"./svg/fi-rr-presentation.svg": "56ab",
	"./svg/fi-rr-print.svg": "8711",
	"./svg/fi-rr-protractor.svg": "e284",
	"./svg/fi-rr-pulse.svg": "2110",
	"./svg/fi-rr-quote-right.svg": "7620",
	"./svg/fi-rr-rec.svg": "f85e",
	"./svg/fi-rr-receipt.svg": "e719",
	"./svg/fi-rr-rectangle-horizontal.svg": "a271",
	"./svg/fi-rr-rectangle-panoramic.svg": "cb9d",
	"./svg/fi-rr-rectangle-vertical.svg": "0310",
	"./svg/fi-rr-redo.svg": "45a1",
	"./svg/fi-rr-reflect.svg": "efd8",
	"./svg/fi-rr-refresh.svg": "01ce",
	"./svg/fi-rr-resize.svg": "37c2",
	"./svg/fi-rr-resources.svg": "0c5c",
	"./svg/fi-rr-rewind.svg": "e8b1",
	"./svg/fi-rr-rocket.svg": "9f57",
	"./svg/fi-rr-rotate-right.svg": "c809",
	"./svg/fi-rr-rugby.svg": "9956",
	"./svg/fi-rr-scale.svg": "3895",
	"./svg/fi-rr-school-bus.svg": "f17a",
	"./svg/fi-rr-school.svg": "967e",
	"./svg/fi-rr-scissors.svg": "b2cb",
	"./svg/fi-rr-screen.svg": "509d",
	"./svg/fi-rr-search-alt.svg": "a5b9",
	"./svg/fi-rr-search.svg": "207e",
	"./svg/fi-rr-settings-sliders.svg": "fe98",
	"./svg/fi-rr-settings.svg": "9d3e",
	"./svg/fi-rr-share.svg": "be84",
	"./svg/fi-rr-shield-check.svg": "eca0",
	"./svg/fi-rr-shield-exclamation.svg": "87b1",
	"./svg/fi-rr-shield-interrogation.svg": "b570",
	"./svg/fi-rr-shield-plus.svg": "95a9",
	"./svg/fi-rr-shield.svg": "6f72",
	"./svg/fi-rr-shop.svg": "5e1d",
	"./svg/fi-rr-shopping-bag-add.svg": "7ffb",
	"./svg/fi-rr-shopping-bag.svg": "1d9f",
	"./svg/fi-rr-shopping-cart-add.svg": "9a2d",
	"./svg/fi-rr-shopping-cart-check.svg": "11b2",
	"./svg/fi-rr-shopping-cart.svg": "e503",
	"./svg/fi-rr-shuffle.svg": "4a0c",
	"./svg/fi-rr-sign-in.svg": "a82c",
	"./svg/fi-rr-sign-out.svg": "dafb",
	"./svg/fi-rr-signal-alt-1.svg": "75ec",
	"./svg/fi-rr-signal-alt-2.svg": "9e17",
	"./svg/fi-rr-signal-alt.svg": "c3f4",
	"./svg/fi-rr-skateboard.svg": "ffa4",
	"./svg/fi-rr-smartphone.svg": "4a9c",
	"./svg/fi-rr-soap.svg": "5a13",
	"./svg/fi-rr-spa.svg": "dfe6",
	"./svg/fi-rr-speaker.svg": "e53e",
	"./svg/fi-rr-spinner-alt.svg": "ed22",
	"./svg/fi-rr-spinner.svg": "40ff",
	"./svg/fi-rr-square-root.svg": "e80a",
	"./svg/fi-rr-square.svg": "301b",
	"./svg/fi-rr-star.svg": "6ad8",
	"./svg/fi-rr-stats.svg": "61f8",
	"./svg/fi-rr-stethoscope.svg": "add9",
	"./svg/fi-rr-sticker.svg": "a50f",
	"./svg/fi-rr-stop.svg": "9cf1",
	"./svg/fi-rr-stopwatch.svg": "c46a",
	"./svg/fi-rr-subtitles.svg": "2363",
	"./svg/fi-rr-surfing.svg": "9ae6",
	"./svg/fi-rr-sword.svg": "d394",
	"./svg/fi-rr-syringe.svg": "a9be",
	"./svg/fi-rr-tablet.svg": "158e",
	"./svg/fi-rr-target.svg": "2001",
	"./svg/fi-rr-tennis.svg": "928b",
	"./svg/fi-rr-test-tube.svg": "8cec",
	"./svg/fi-rr-test.svg": "0f78",
	"./svg/fi-rr-text-check.svg": "8ba9",
	"./svg/fi-rr-text.svg": "f849",
	"./svg/fi-rr-thumbs-down.svg": "2440",
	"./svg/fi-rr-thumbs-up.svg": "0942",
	"./svg/fi-rr-ticket.svg": "a1b4",
	"./svg/fi-rr-time-add.svg": "2d24",
	"./svg/fi-rr-time-check.svg": "fd98",
	"./svg/fi-rr-time-delete.svg": "4051",
	"./svg/fi-rr-time-fast.svg": "e1d6",
	"./svg/fi-rr-time-forward-sixty.svg": "f041",
	"./svg/fi-rr-time-forward-ten.svg": "8011",
	"./svg/fi-rr-time-forward.svg": "1997",
	"./svg/fi-rr-time-half-past.svg": "01af",
	"./svg/fi-rr-time-oclock.svg": "be78",
	"./svg/fi-rr-time-past.svg": "8332",
	"./svg/fi-rr-time-quarter-past.svg": "3679",
	"./svg/fi-rr-time-quarter-to.svg": "bb95",
	"./svg/fi-rr-time-twenty-four.svg": "b9f5",
	"./svg/fi-rr-tool-crop.svg": "a150",
	"./svg/fi-rr-tool-marquee.svg": "5c47",
	"./svg/fi-rr-tooth.svg": "548e",
	"./svg/fi-rr-transform.svg": "f660",
	"./svg/fi-rr-trash.svg": "29ce",
	"./svg/fi-rr-treatment.svg": "31da",
	"./svg/fi-rr-trophy.svg": "9d2e",
	"./svg/fi-rr-umbrella.svg": "8faf",
	"./svg/fi-rr-underline.svg": "a510",
	"./svg/fi-rr-undo.svg": "612c",
	"./svg/fi-rr-unlock.svg": "98c6",
	"./svg/fi-rr-upload.svg": "afba",
	"./svg/fi-rr-usb-drive.svg": "5107",
	"./svg/fi-rr-user-add.svg": "65ba",
	"./svg/fi-rr-user-delete.svg": "1154",
	"./svg/fi-rr-user-remove.svg": "d21f",
	"./svg/fi-rr-user-time.svg": "ebc4",
	"./svg/fi-rr-user.svg": "708f",
	"./svg/fi-rr-users.svg": "97be",
	"./svg/fi-rr-vector-alt.svg": "11bc",
	"./svg/fi-rr-vector.svg": "acc9",
	"./svg/fi-rr-video-camera.svg": "7cfc",
	"./svg/fi-rr-volleyball.svg": "32bf",
	"./svg/fi-rr-volume.svg": "560e",
	"./svg/fi-rr-wifi-alt.svg": "d0e7",
	"./svg/fi-rr-world.svg": "7d91",
	"./svg/fi-rr-yen.svg": "b12c",
	"./svg/fi-rr-zoom-in.svg": "cbad",
	"./svg/fi-rr-zoom-out.svg": "0ca8",
	"./szukaj-min.png": "6b6d",
	"./test": "b2ef",
	"./thanks-min.png": "f8f3",
	"./thankyou_min.png": "b4b5",
	"./theMoon.svg": "6855",
	"./transfer.svg": "1f3c",
	"./transfer_endOrder.svg": "eb14",
	"./up-arrow.svg": "0d36",
	"./userForm.svg": "aa51",
	"./vat0/PDF.png": "9854",
	"./vat0/doc.png": "8950",
	"./vat0/drukarka.png": "7df3",
	"./vat0/formularz.png": "29f6",
	"./vat0/instytucja.png": "ee1e",
	"./vat0/komputer.png": "c499",
	"./vat0/monitor.png": "208c",
	"./vat0/organizacja.png": "af72",
	"./vat0/szkola.png": "d0dc",
	"./vat0/trust.png": "3a48",
	"./vat0/wysylka.png": "a8a4",
	"./vat0/zalacznik.png": "d935",
	"./visitors.svg": "9a19",
	"./waitForDelivery.svg": "edb9",
	"./warehouse-min.png": "e7ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";